module.exports = __webpack_public_path__ + "static/media/preloader_02_01.7acf5c50.gif";